import { ScrollBarContext } from "./scroll-bar.context";
import { ScrollBarCaret } from "./parts/view-caret";
import { ScrollBarThumb } from "./parts/view-thumb";
import { ScrollBarTrack } from "./parts/view-track";
import type { ScrollBarProps } from "./types-scroll-bar";
import { useScrollBar } from "./use-scroll-bar";
import { ScrollBarView } from "./view-scroll-bar";

export function ScrollBarRoot({ children, ...options }: ScrollBarProps) {
  const viewModel = useScrollBar(options);

  return (
    <ScrollBarContext.Provider value={viewModel}>
      <ScrollBarView
        visible={viewModel.visible}
        orientation={viewModel.orientation}
        controls={viewModel.controls}
        testId={viewModel.testId}
        className={viewModel.className}
        style={viewModel.style}
        rest={viewModel.rest}
        rootRef={viewModel.rootRef}
        onKeyDown={viewModel.onKeyDown}
      >
        {children ?? (
          <>
            <ScrollBarTrack />
            <ScrollBarThumb />
            {viewModel.carets.map((direction) => (
              <ScrollBarCaret key={direction} direction={direction} />
            ))}
          </>
        )}
      </ScrollBarView>
    </ScrollBarContext.Provider>
  );
}
ScrollBarRoot.displayName = "ScrollBar.Root";
